module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/31.a5bab3e5.png";